import { Component, OnInit } from '@angular/core';
import { IAccount } from '../../../store/models/account.model';
import { AccountsUnderComponent } from '../../list-accounts/accounts-under/accounts-under.component';
import { ButtonColor, ButtonSize } from '../../../store/models/button.model';
import { Store } from '@ngrx/store';
import { IReducers } from '../../../store/reducers';
import { openDialog } from '../../../store/actions/page.action';

@Component({
  selector: 'app-manager-role-renderer',
  templateUrl: './manager-role-renderer.component.html',
  styleUrls: ['./manager-role-renderer.component.scss'],
})
export class ManagerRoleRendererComponent implements OnInit {
  account: IAccount;

  constructor(private readonly store$: Store<IReducers>) {}

  ngOnInit() {}

  ucFirst(inputString: string): string {
    if (!inputString) {
      return '';
    }

    return inputString.charAt(0).toUpperCase() + inputString.slice(1);
  }

  openDialog() {
    this.store$.dispatch(
      openDialog({
        dialogData: {
          title: `User Account(s) under ${this.account.first_name} ${this.account.last_name}`,
          content: AccountsUnderComponent,
          componentData: {
            items: this.account.visible_users,
          },
          dialogMinWidth: '1000px',
          canClose: true,
        },
      })
    );
  }
}
